import InstallmentPayment from '@/views/InstallmentPayment.vue'

export default {
  path: '/:hash/platnosc-ratalna',
  props: true,
  name: 'InstallmentPayment',
  component: InstallmentPayment,
  meta: {
    title: 'Płatność ratalna - Ścieżka Wyboru Dzieci',
    metaTags: [{ name: 'robots', content: 'noindex' }]
  }
}
